import { defineStore } from 'pinia'
import type { FileListTypeProperty } from '@ve-pro/ve/aside/config/aside-type'
import { LayerConfig } from '@ve-pro/ve/forbidden-font/type'
import { t } from '@ve-pro/ve/lang'

export const useMaterialStore = defineStore('material', {
  state: () => {
    return {
      materialData: [] as FileListTypeProperty[],
      // 点击的待分镜视频asset_id
      clipAssetIds: [] as number[],
      // 下架字体弹框数据
      forbiddenFontDialog: {
        visible: false,
        loading: false,
        fontOptions: [],
        message: t('forbiddenFont.msg'),
        tool: 2,
        forbiddenFontList: {},
        assetFontConfig: { list: true },
      } as LayerConfig,
    }
  },
  getters: {
    // 判断当前素材是否存在
    inMaterialData: (state) => (asset_id: number) => {
      return state.materialData.some(
        (item: { asset_id: number }) => item.asset_id === asset_id,
      )
    },
    // 根据asset_id查找资产
    getAssetMaterial: (state) => (asset_id: number) => {
      return state.materialData.filter(
        (item: { asset_id: number }) => item.asset_id === asset_id,
      )
    },
  },
  actions: {
    setMaterialData(data: FileListTypeProperty[]) {
      this.materialData = data
    },
    updateForbiddenFontDialog(data: Partial<LayerConfig>) {
      Object.assign(this.forbiddenFontDialog, data)
    },
    addClipAssetIds(id: number) {
      this.clipAssetIds.push(id)
    },
    deleteClipAssetIds(id: number) {
      this.clipAssetIds = this.clipAssetIds.filter((item) => {
        return item !== id
      })
    },
  },
})
